import React from 'react'
import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Pages
import { Login } from './pages/Auth'
import { Dashboard, DashboardAIAnalytics } from './pages/Dashboard'
import MyProfile from './pages/Account/MyProfile'
import { Sales } from './pages/Sales'
import SalesStageMaster from './pages/Sales/Pipeline/SalesStageMaster'
import OpportunityList from './pages/Sales/Pipeline/OpportunityList'
import PipelineReports from './pages/Sales/Pipeline/PipelineReports'
import { CRM } from './pages/CRM'
import { Contracts } from './pages/Contracts'
import { Projects } from './pages/Projects'
import ProjectTypeMaster from './pages/Projects/ProjectTypeMaster'
import ProjectTypeMasterForm from './pages/Projects/ProjectTypeMasterForm'
import ProjectTypeMasterEdit from './pages/Projects/ProjectTypeMasterEdit'
import ProjectCategoryMaster from './pages/Projects/ProjectCategoryMaster'
import ProjectCategoryMasterForm from './pages/Projects/ProjectCategoryMasterForm'
import ProjectCategoryMasterEdit from './pages/Projects/ProjectCategoryMasterEdit'
import PricingModelMaster from './pages/Projects/PricingModelMaster'
import PricingModelMasterForm from './pages/Projects/PricingModelMasterForm'
import PricingModelMasterEdit from './pages/Projects/PricingModelMasterEdit'
import ProjectStatusMaster from './pages/Projects/ProjectStatusMaster'
import ProjectStatusMasterForm from './pages/Projects/ProjectStatusMasterForm'
import ProjectStatusMasterEdit from './pages/Projects/ProjectStatusMasterEdit'
import PriorityMaster from './pages/Projects/PriorityMaster'
import PriorityMasterForm from './pages/Projects/PriorityMasterForm'
import PriorityMasterEdit from './pages/Projects/PriorityMasterEdit'
import TechnologyStackMaster from './pages/Projects/TechnologyStackMaster'
import TechnologyStackMasterForm from './pages/Projects/TechnologyStackMasterForm'
import TechnologyStackMasterEdit from './pages/Projects/TechnologyStackMasterEdit'
import ResourceRoleMaster from './pages/Projects/ResourceRoleMaster'
import ResourceRoleMasterForm from './pages/Projects/ResourceRoleMasterForm'
import ResourceRoleMasterEdit from './pages/Projects/ResourceRoleMasterEdit'
import ProjectTemplateMaster from './pages/Projects/ProjectTemplateMaster'
import ProjectTemplateMasterForm from './pages/Projects/ProjectTemplateMasterForm'
import ProjectTemplateMasterEdit from './pages/Projects/ProjectTemplateMasterEdit'
import ProjectList from './pages/Projects/ProjectList'
import ProjectForm from './pages/Projects/ProjectForm'
import ProjectEdit from './pages/Projects/ProjectEdit'
import ProjectView from './pages/Projects/ProjectView'
import TaskList from './pages/Projects/Tasks/TaskList'
import TaskForm from './pages/Projects/Tasks/TaskForm'
import TaskEdit from './pages/Projects/Tasks/TaskEdit'
import TaskView from './pages/Projects/Tasks/TaskView'
import ProjectExpenseList from './pages/Projects/Expenses/ProjectExpenseList'
import ProjectExpenseForm from './pages/Projects/Expenses/ProjectExpenseForm'
import ProjectExpenseEdit from './pages/Projects/Expenses/ProjectExpenseEdit'
import ProjectExpenseView from './pages/Projects/Expenses/ProjectExpenseView'
import Milestones from './pages/Projects/Milestones/Milestones'
import MilestoneList from './pages/Projects/Milestones/MilestoneList'
import MilestoneForm from './pages/Projects/Milestones/MilestoneForm'
import MilestoneEdit from './pages/Projects/Milestones/MilestoneEdit'
import MilestoneView from './pages/Projects/Milestones/MilestoneView'
import ResourceAllocations from './pages/Projects/ResourceAllocations/ResourceAllocations'
import ResourceAllocationList from './pages/Projects/ResourceAllocations/ResourceAllocationList'
import ResourceAllocationForm from './pages/Projects/ResourceAllocations/ResourceAllocationForm'
import ResourceAllocationEdit from './pages/Projects/ResourceAllocations/ResourceAllocationEdit'
import ResourceAllocationView from './pages/Projects/ResourceAllocations/ResourceAllocationView'
import BudgetPlannings from './pages/Projects/BudgetPlannings/BudgetPlannings'
import BudgetPlanningList from './pages/Projects/BudgetPlannings/BudgetPlanningList'
import BudgetPlanningForm from './pages/Projects/BudgetPlannings/BudgetPlanningForm'
import BudgetPlanningEdit from './pages/Projects/BudgetPlannings/BudgetPlanningEdit'
import BudgetPlanningView from './pages/Projects/BudgetPlannings/BudgetPlanningView'
import ProjectBillingList from './pages/Projects/Billings/ProjectBillingList'
import ProjectBillingForm from './pages/Projects/Billings/ProjectBillingForm'
import ChangeRequestList from './pages/Projects/ChangeRequests/ChangeRequestList'
import ChangeRequestForm from './pages/Projects/ChangeRequests/ChangeRequestForm'
import ProjectDocumentList from './pages/Projects/Documents/ProjectDocumentList'
import ProjectDocumentForm from './pages/Projects/Documents/ProjectDocumentForm'
import ProjectCommunicationList from './pages/Projects/Communications/ProjectCommunicationList'
import ProjectCommunicationForm from './pages/Projects/Communications/ProjectCommunicationForm'
import ResourceCalendar from './pages/Projects/ResourceCalendar/ResourceCalendar'
import ResourceCalendarForm from './pages/Projects/ResourceCalendar/ResourceCalendarForm'
import { Timesheets } from './pages/Timesheets'
import TimesheetList from './pages/Timesheets/TimesheetList'
import TimesheetForm from './pages/Timesheets/TimesheetForm'
import TimesheetEdit from './pages/Timesheets/TimesheetEdit'
import TimesheetView from './pages/Timesheets/TimesheetView'
import { Expenses } from './pages/Expenses'
import EmployeeMaster from './pages/Expenses/EmployeeMaster'
import EmployeeMasterForm from './pages/Expenses/EmployeeMasterForm'
import ExpenseCategoryMaster from './pages/Expenses/ExpenseCategoryMaster'
import ExpenseCategoryMasterForm from './pages/Expenses/ExpenseCategoryMasterForm'
import PaymentMethodMaster from './pages/Expenses/PaymentMethodMaster'
import PaymentMethodMasterForm from './pages/Expenses/PaymentMethodMasterForm'
import ApproverMaster from './pages/Expenses/ApproverMaster'
import ApproverMasterForm from './pages/Expenses/ApproverMasterForm'
import ExpenseClaim from './pages/Expenses/ExpenseClaim'
import ExpenseClaimForm from './pages/Expenses/ExpenseClaimForm'
import ExpenseApproval from './pages/Expenses/ExpenseApproval'
import ExpenseReimbursement from './pages/Expenses/ExpenseReimbursement'
import ExpenseReimbursementForm from './pages/Expenses/ExpenseReimbursementForm'
import AdvancePayment from './pages/Expenses/AdvancePayment'
import AdvancePaymentForm from './pages/Expenses/AdvancePaymentForm'
import ExpenseAnalysis from './pages/Expenses/ExpenseAnalysis'
import EmployeeReports from './pages/Expenses/EmployeeReports'
import DepartmentReports from './pages/Expenses/DepartmentReports'
import BudgetReports from './pages/Expenses/BudgetReports'
import BudgetVsActual from './pages/Expenses/BudgetVsActual'
import FinancialYearBudget from './pages/Expenses/FinancialYearBudget'
import BurnExpenseCategoryMaster from './pages/Expenses/BurnExpenseCategoryMaster'
import BurnExpenseEntry from './pages/Expenses/BurnExpenseEntry'
import BurnReports from './pages/Expenses/BurnReports'
import TimeEntry from './pages/Timesheets/TimeEntry'
import TimeEntryForm from './pages/Timesheets/TimeEntryForm'
import WeeklyTimesheet from './pages/Timesheets/WeeklyTimesheet'
import WeeklyTimesheetForm from './pages/Timesheets/WeeklyTimesheetForm'
import TimesheetApproval from './pages/Timesheets/TimesheetApproval'
import TimesheetApprovalForm from './pages/Timesheets/TimesheetApprovalForm'
import Overtime from './pages/Timesheets/Overtime'
import OvertimeForm from './pages/Timesheets/OvertimeForm'
import DraftContract from './pages/Contracts/DraftContract'
import DraftContractForm from './pages/Contracts/DraftContractForm'
import SignedContract from './pages/Contracts/SignedContract'
import SignedContractForm from './pages/Contracts/SignedContractForm'
import ContractRenewal from './pages/Contracts/ContractRenewal'
import ContractRenewalForm from './pages/Contracts/ContractRenewalForm'
import ArchivedContract from './pages/Contracts/ArchivedContract'
import ArchivedContractView from './pages/Contracts/ArchivedContractView'
import ContractTypeMaster from './pages/Contracts/ContractTypeMaster'
import ContractTypeMasterForm from './pages/Contracts/ContractTypeMasterForm'
import LegalTermsMaster from './pages/Contracts/LegalTermsMaster'
import LegalTermsMasterForm from './pages/Contracts/LegalTermsMasterForm'
import ApprovalWorkflowMaster from './pages/Contracts/ApprovalWorkflowMaster'
import ApprovalWorkflowMasterForm from './pages/Contracts/ApprovalWorkflowMasterForm'
import ComplianceRuleMaster from './pages/Contracts/ComplianceRuleMaster'
import ComplianceRuleMasterForm from './pages/Contracts/ComplianceRuleMasterForm'
import ContractPerformanceReport from './pages/Contracts/Reports/ContractPerformanceReport'
import ContractRenewalReport from './pages/Contracts/Reports/ContractRenewalReport'
import ContractComplianceReport from './pages/Contracts/Reports/ContractComplianceReport'
import ContractFinancialReport from './pages/Contracts/Reports/ContractFinancialReport'
import { Procurement } from './pages/Procurement'
import { Assets } from './pages/Assets'
import AssetTypeMaster from './pages/Assets/AssetTypeMaster'
import AssetTypeMasterForm from './pages/Assets/AssetTypeMasterForm'
import AssetLocationMaster from './pages/Assets/AssetLocationMaster'
import AssetLocationMasterForm from './pages/Assets/AssetLocationMasterForm'
import AssetVendorMaster from './pages/Assets/AssetVendorMaster'
import AssetVendorMasterForm from './pages/Assets/AssetVendorMasterForm'
import MaintenanceProviderMaster from './pages/Assets/MaintenanceProviderMaster'
import MaintenanceProviderMasterForm from './pages/Assets/MaintenanceProviderMasterForm'
import AssetAcquisitions from './pages/Assets/AssetAcquisitions'
import AssetAcquisitionForm from './pages/Assets/AssetAcquisitionForm'
import AssetAssignments from './pages/Assets/AssetAssignments'
import AssetAssignmentForm from './pages/Assets/AssetAssignmentForm'
import AssetMaintenanceList from './pages/Assets/AssetMaintenanceList'
import AssetMaintenanceForm from './pages/Assets/AssetMaintenanceForm'
import AssetDisposals from './pages/Assets/AssetDisposals'
import AssetDisposalForm from './pages/Assets/AssetDisposalForm'
import AssetValuationReport from './pages/Assets/Reports/AssetValuationReport'
import AssetUtilizationReport from './pages/Assets/Reports/UtilizationReport'
import AssetMaintenanceReport from './pages/Assets/Reports/MaintenanceReport'
import AssetFinancialReport from './pages/Assets/Reports/FinancialReport'
import SupplierMaster from './pages/Procurement/SupplierMaster'
import SupplierMasterForm from './pages/Procurement/SupplierMasterForm'
import ProductMaster from './pages/Procurement/ProductMaster'
import ProductMasterForm from './pages/Procurement/ProductMasterForm'
import CategoryMaster from './pages/Procurement/CategoryMaster'
import CategoryMasterForm from './pages/Procurement/CategoryMasterForm'
import ProcurementServiceMaster from './pages/Procurement/ProcurementServiceMaster'
import ProcurementServiceMasterForm from './pages/Procurement/ProcurementServiceMasterForm'
import ProcurementApproverMaster from './pages/Procurement/ProcurementApproverMaster'
import ProcurementApproverMasterForm from './pages/Procurement/ProcurementApproverMasterForm'
import PurchaseRequisition from './pages/Procurement/PurchaseRequisition'
import PurchaseRequisitionForm from './pages/Procurement/PurchaseRequisitionForm'
import PurchaseOrder from './pages/Procurement/PurchaseOrder'
import PurchaseOrderForm from './pages/Procurement/PurchaseOrderForm'
import GoodsReceiptNote from './pages/Procurement/GoodsReceiptNote'
import GoodsReceiptNoteForm from './pages/Procurement/GoodsReceiptNoteForm'
import VendorInvoice from './pages/Procurement/VendorInvoice'
import VendorInvoiceForm from './pages/Procurement/VendorInvoiceForm'
import PurchaseAnalysis from './pages/Procurement/PurchaseAnalysis'
import SupplierReports from './pages/Procurement/SupplierReports'
import InventoryReports from './pages/Procurement/InventoryReports'
import CostReports from './pages/Procurement/CostReports'
import { Subscriptions } from './pages/Subscriptions'
import SubscriptionList from './pages/Subscriptions/SubscriptionList'
import SubscriptionForm from './pages/Subscriptions/SubscriptionForm'
import RenewalList from './pages/Subscriptions/RenewalList'
import SubscriptionPaymentList from './pages/Subscriptions/PaymentList'
import SubscriptionPaymentForm from './pages/Subscriptions/PaymentForm'
import ExpirationList from './pages/Subscriptions/ExpirationList'
import { Billing } from './pages/Billing'
import { AIAssistant } from './pages/AIAssistant'
import { Settings } from './pages/Settings'
import { Support } from './pages/Support'
import SupportTicketList from './pages/Support/SupportTicketList'
import SupportTicketForm from './pages/Support/SupportTicketForm'
import SupportTicketEdit from './pages/Support/SupportTicketEdit'
import SupportTicketView from './pages/Support/SupportTicketView'
import { Development } from './pages/Development'
import { 
  SACMaster, SACMasterForm, SACMasterEdit, SACMasterView,
  ServiceMaster, ServiceMasterForm, ServiceMasterEdit, ServiceMasterView,
  PaymentTermsMaster, PaymentTermsMasterForm, PaymentTermsMasterEdit, PaymentTermsMasterView,
  CustomerMaster, CustomerMasterForm, CustomerMasterEdit, CustomerMasterView
} from './pages/Sales'
import TaxInvoice from './pages/Sales/TaxInvoice'
import TaxInvoiceForm from './pages/Sales/TaxInvoiceForm'
import ProformaInvoice from './pages/Sales/ProformaInvoice'
import ProformaInvoiceForm from './pages/Sales/ProformaInvoiceForm'
import TaxInvoiceReport from './pages/Sales/Reports/TaxInvoiceReport'
import SalesOverviewReport from './pages/Sales/Reports/SalesOverviewReport'
import ProformaInvoiceReport from './pages/Sales/Reports/ProformaInvoiceReport'
import InvoiceAgingReport from './pages/Accounts/Reports/InvoiceAgingReport'
import SundryDebtorsReport from './pages/Accounts/Reports/SundryDebtorsReport'
import OutstandingPaymentsReport from './pages/Accounts/Reports/OutstandingPaymentsReport'
import FounderControlReport from './pages/Accounts/Reports/FounderControlReport'
import BurnDisciplineReport from './pages/Accounts/Reports/BurnDisciplineReport'
import RunwaySensitivityReport from './pages/Accounts/Reports/RunwaySensitivityReport'
import {
  Management,
  DirectorsBusinessReview,
  MisSnapshotReport,
  FinancialHealthReport,
  SalesPipelineRevenueReport,
  ProjectPortfolioHealthReport,
  ResourceCapacityReport,
  CustomerCollectionHealthReport,
  ExpenseBudgetPerformanceReport,
  RenewalsCommitmentsReport,
  RiskComplianceActionTracker
} from './pages/Management'
import Payments from './pages/Accounts/Payments'
import PaymentForm from './pages/Accounts/PaymentForm'
import CashAccountMaster from './pages/Accounts/CashAccountMaster'
import CashTransactions from './pages/Accounts/CashTransactions'
import SalesQuotationReport from './pages/Sales/Reports/SalesQuotationReport'
import SalesQuotation from './pages/Sales/SalesQuotation'
import SalesQuotationForm from './pages/Sales/SalesQuotationForm'
import SalesRegisterReport from './pages/Sales/Reports/SalesRegisterReport'
import TaxInvoicePrint from './pages/Sales/Reports/TaxInvoicePrint'
import ProformaInvoicePrint from './pages/Sales/Reports/ProformaInvoicePrint'
import SalesQuotationPrint from './pages/Sales/Reports/SalesQuotationPrint'
import ProspectMaster from './pages/CRM/ProspectMaster'
import ProspectMasterForm from './pages/CRM/ProspectMasterForm'
import ProspectMasterEdit from './pages/CRM/ProspectMasterEdit'
import ProspectMasterView from './pages/CRM/ProspectMasterView'
import UploadProspect from './pages/CRM/UploadProspect'
import LeadSourceMaster from './pages/CRM/LeadSourceMaster'
import LeadSourceMasterForm from './pages/CRM/LeadSourceMasterForm'
import LeadSourceMasterEdit from './pages/CRM/LeadSourceMasterEdit'
import LeadSourceMasterView from './pages/CRM/LeadSourceMasterView'
import CampaignMaster from './pages/CRM/CampaignMaster'
import CampaignMasterForm from './pages/CRM/CampaignMasterForm'
import CampaignMasterEdit from './pages/CRM/CampaignMasterEdit'
import CampaignMasterView from './pages/CRM/CampaignMasterView'
import LeadManagement from './pages/CRM/LeadManagement'
import LeadManagementForm from './pages/CRM/LeadManagementForm'
import LeadTracking from './pages/CRM/LeadTracking'
import LeadTrackingForm from './pages/CRM/LeadTrackingForm'
import DemoScheduling from './pages/CRM/DemoScheduling'
import DemoSchedulingForm from './pages/CRM/DemoSchedulingForm'
import CommercialProposal from './pages/CRM/CommercialProposal'
import CommercialProposalForm from './pages/CRM/CommercialProposalForm'
import Emails from './pages/CRM/Emails'
import EmailForm from './pages/CRM/EmailForm'
import Calls from './pages/CRM/Calls'
import CallsForm from './pages/CRM/CallsForm'
import FollowUp from './pages/CRM/FollowUp'
import FollowUpForm from './pages/CRM/FollowUpForm'
import SalesPerformanceReport from './pages/CRM/Reports/SalesPerformanceReport'
import LeadReports from './pages/CRM/Reports/LeadReports'
import CustomerAnalytics from './pages/CRM/Reports/CustomerAnalytics'
import ReportLayout from './layouts/ReportLayout'
import { 
  GlobalMaster,
  SecurityMaster,
  OrganisationMaster,
  SystemConfiguration,
  NotificationsHub,
  DropdownMaster, DropdownMasterForm, DropdownMasterEdit, DropdownMasterView,
  AutoIncrementMasterForm, AutoIncrementMasterEdit, AutoIncrementMasterView,
  UserMaster, UserMasterForm, UserMasterEdit, UserMasterView,
  RoleMaster, RoleMasterForm, RoleMasterEdit, RoleMasterView,
  MenuItemMaster, MenuItemMasterForm, MenuItemMasterEdit, MenuItemMasterView,
  SubmoduleMaster, SubmoduleMasterForm, SubmoduleMasterEdit, SubmoduleMasterView,
  ModulePermissions,
  EmailNotifications,
  GstReminderSettings,
  ApplicationParameters,
} from './pages/Settings'
import AutoIncrementMaster from './pages/Settings/AutoIncrementMaster'
import ExportDetails from './pages/Settings/ExportDetails'
import ComingSoon from './pages/Settings/ComingSoon'
import CompanyMaster from './pages/Settings/CompanyMaster'
import Layout from './components/Layout/Layout'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'

// Legacy notification deep-link: /task/:id → task view
const LegacyTaskRedirect = () => {
  const { id } = useParams()
  return <Navigate to={`/projects/tasks/view/${id}`} replace />
}

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  
  // Show loading only briefly on initial load
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    )
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return children
}

// Public Route Component (redirect to dashboard if already logged in)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  
  // Show loading during authentication check
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    )
  }
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }
  
  return children
}

function App() {
  return (
    <AuthProvider>
        <div className="App">
          <ScrollToTop />
          <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        
        {/* Protected Routes */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
                >
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="profile" element={<MyProfile />} />
                  <Route path="dashboard/ai-analytics" element={<DashboardAIAnalytics />} />
                  <Route path="sales" element={<Sales />} />
                  <Route path="crm" element={<CRM />} />
                  <Route path="contracts" element={<Contracts />} />
                  <Route path="projects" element={<Projects />} />
                  <Route path="projects/project-type-master" element={<ProjectTypeMaster />} />
                  <Route path="projects/project-type-master/new" element={<ProjectTypeMasterForm />} />
                  <Route path="projects/project-type-master/edit" element={<ProjectTypeMasterEdit />} />
                  <Route path="projects/project-category-master" element={<ProjectCategoryMaster />} />
                  <Route path="projects/project-category-master/new" element={<ProjectCategoryMasterForm />} />
                  <Route path="projects/project-category-master/edit" element={<ProjectCategoryMasterEdit />} />
                  <Route path="projects/pricing-model-master" element={<PricingModelMaster />} />
                  <Route path="projects/pricing-model-master/new" element={<PricingModelMasterForm />} />
                  <Route path="projects/pricing-model-master/edit" element={<PricingModelMasterEdit />} />
                  <Route path="projects/project-status-master" element={<ProjectStatusMaster />} />
                  <Route path="projects/project-status-master/new" element={<ProjectStatusMasterForm />} />
                  <Route path="projects/project-status-master/edit" element={<ProjectStatusMasterEdit />} />
                  <Route path="projects/priority-master" element={<PriorityMaster />} />
                  <Route path="projects/priority-master/new" element={<PriorityMasterForm />} />
                  <Route path="projects/priority-master/edit" element={<PriorityMasterEdit />} />
                  <Route path="projects/technology-stack-master" element={<TechnologyStackMaster />} />
                  <Route path="projects/technology-stack-master/new" element={<TechnologyStackMasterForm />} />
                  <Route path="projects/technology-stack-master/edit/:id" element={<TechnologyStackMasterEdit />} />
                  <Route path="projects/resource-role-master" element={<ResourceRoleMaster />} />
                  <Route path="projects/resource-role-master/new" element={<ResourceRoleMasterForm />} />
                  <Route path="projects/resource-role-master/edit/:id" element={<ResourceRoleMasterEdit />} />
                  <Route path="projects/project-template-master" element={<ProjectTemplateMaster />} />
                  <Route path="projects/project-template-master/new" element={<ProjectTemplateMasterForm />} />
                  <Route path="projects/project-template-master/edit/:id" element={<ProjectTemplateMasterEdit />} />
                  <Route path="projects/list" element={<ProjectList />} />
                  <Route path="projects/new" element={<ProjectForm />} />
                  <Route path="projects/edit/:id" element={<ProjectEdit />} />
                  <Route path="projects/view/:id" element={<ProjectView />} />
                  <Route path="projects/tasks/list" element={<TaskList />} />
                  <Route path="projects/tasks/new" element={<TaskForm />} />
                  <Route path="projects/tasks/edit/:id" element={<TaskEdit />} />
                  <Route path="projects/tasks/view/:id" element={<TaskView />} />
                  {/* Legacy notification deep-links */}
                  <Route path="task/:id" element={<LegacyTaskRedirect />} />
                  <Route path="projects/expenses/list" element={<ProjectExpenseList />} />
                  <Route path="projects/expenses/new" element={<ProjectExpenseForm />} />
                  <Route path="projects/expenses/edit/:id" element={<ProjectExpenseEdit />} />
                  <Route path="projects/expenses/view/:id" element={<ProjectExpenseView />} />
                  <Route path="projects/milestones" element={<Milestones />} />
                  <Route path="projects/milestones/list" element={<MilestoneList />} />
                  <Route path="projects/milestones/new" element={<MilestoneForm />} />
                  <Route path="projects/milestones/edit/:id" element={<MilestoneEdit />} />
                  <Route path="projects/milestones/view/:id" element={<MilestoneView />} />
                  <Route path="projects/resource-allocations" element={<ResourceAllocations />} />
                  <Route path="projects/resource-allocations/list" element={<ResourceAllocationList />} />
                  <Route path="projects/resource-allocations/new" element={<ResourceAllocationForm />} />
                  <Route path="projects/resource-allocations/edit/:id" element={<ResourceAllocationEdit />} />
                  <Route path="projects/resource-allocations/view/:id" element={<ResourceAllocationView />} />
                  <Route path="projects/budget-plannings" element={<BudgetPlannings />} />
                  <Route path="projects/budget-plannings/list" element={<BudgetPlanningList />} />
                  <Route path="projects/budget-plannings/new" element={<BudgetPlanningForm />} />
                  <Route path="projects/budget-plannings/edit/:id" element={<BudgetPlanningEdit />} />
                  <Route path="projects/budget-plannings/view/:id" element={<BudgetPlanningView />} />
                  <Route path="projects/billings" element={<ProjectBillingList />} />
                  <Route path="projects/billings/new" element={<ProjectBillingForm mode="create" />} />
                  <Route path="projects/billings/edit/:id" element={<ProjectBillingForm mode="edit" />} />
                  <Route path="projects/billings/view/:id" element={<ProjectBillingForm mode="view" />} />
                  <Route path="projects/change-requests" element={<ChangeRequestList />} />
                  <Route path="projects/change-requests/new" element={<ChangeRequestForm mode="create" />} />
                  <Route path="projects/change-requests/edit/:id" element={<ChangeRequestForm mode="edit" />} />
                  <Route path="projects/change-requests/view/:id" element={<ChangeRequestForm mode="view" />} />
                  <Route path="projects/documents" element={<ProjectDocumentList />} />
                  <Route path="projects/documents/new" element={<ProjectDocumentForm mode="create" />} />
                  <Route path="projects/documents/edit/:id" element={<ProjectDocumentForm mode="edit" />} />
                  <Route path="projects/documents/view/:id" element={<ProjectDocumentForm mode="view" />} />
                  <Route path="projects/communications" element={<ProjectCommunicationList />} />
                  <Route path="projects/communications/new" element={<ProjectCommunicationForm mode="create" />} />
                  <Route path="projects/communications/edit/:id" element={<ProjectCommunicationForm mode="edit" />} />
                  <Route path="projects/communications/view/:id" element={<ProjectCommunicationForm mode="view" />} />
                  <Route path="projects/resource-calendar" element={<ResourceCalendar />} />
                  <Route path="projects/resource-calendar/new" element={<ResourceCalendarForm mode="create" />} />
                  <Route path="projects/resource-calendar/edit/:id" element={<ResourceCalendarForm mode="edit" />} />
                  <Route path="projects/resource-calendar/view/:id" element={<ResourceCalendarForm mode="view" />} />
                  <Route path="timesheets/list" element={<TimesheetList />} />
                  <Route path="timesheets/new" element={<TimesheetForm />} />
                  <Route path="timesheets/edit/:id" element={<TimesheetEdit />} />
                  <Route path="timesheets/view/:id" element={<TimesheetView />} />
                  <Route path="contracts" element={<Contracts />} />
                  <Route path="contracts/draft-contract" element={<DraftContract />} />
                  <Route path="contracts/draft-contract/form" element={<DraftContractForm />} />
                  <Route path="contracts/draft-contract/edit" element={<DraftContractForm />} />
                  <Route path="contracts/draft-contract/view" element={<DraftContractForm />} />
                  <Route path="contracts/signed-contract" element={<SignedContract />} />
                  <Route path="contracts/signed-contract/form" element={<SignedContractForm />} />
                  <Route path="contracts/signed-contract/edit" element={<SignedContractForm />} />
                  <Route path="contracts/signed-contract/view" element={<SignedContractForm />} />
                  <Route path="contracts/contract-renewal" element={<ContractRenewal />} />
                  <Route path="contracts/contract-renewal/form" element={<ContractRenewalForm />} />
                  <Route path="contracts/contract-renewal/edit" element={<ContractRenewalForm />} />
                  <Route path="contracts/contract-renewal/view" element={<ContractRenewalForm />} />
                  <Route path="contracts/archived-contract" element={<ArchivedContract />} />
                  <Route path="contracts/archived-contract/view" element={<ArchivedContractView />} />
                  <Route path="contracts/contract-type-master" element={<ContractTypeMaster />} />
                  <Route path="contracts/contract-type-master/form" element={<ContractTypeMasterForm />} />
                  <Route path="contracts/contract-type-master/edit" element={<ContractTypeMasterForm />} />
                  <Route path="contracts/contract-type-master/view" element={<ContractTypeMasterForm />} />
                  <Route path="contracts/legal-terms-master" element={<LegalTermsMaster />} />
                  <Route path="contracts/legal-terms-master/form" element={<LegalTermsMasterForm />} />
                  <Route path="contracts/legal-terms-master/edit" element={<LegalTermsMasterForm />} />
                  <Route path="contracts/legal-terms-master/view" element={<LegalTermsMasterForm />} />
                  <Route path="contracts/approval-workflow-master" element={<ApprovalWorkflowMaster />} />
                  <Route path="contracts/approval-workflow-master/form" element={<ApprovalWorkflowMasterForm />} />
                  <Route path="contracts/approval-workflow-master/edit" element={<ApprovalWorkflowMasterForm />} />
                  <Route path="contracts/approval-workflow-master/view" element={<ApprovalWorkflowMasterForm />} />
                  <Route path="contracts/compliance-rule-master" element={<ComplianceRuleMaster />} />
                  <Route path="contracts/compliance-rule-master/form" element={<ComplianceRuleMasterForm />} />
                  <Route path="contracts/compliance-rule-master/edit" element={<ComplianceRuleMasterForm />} />
                  <Route path="contracts/compliance-rule-master/view" element={<ComplianceRuleMasterForm />} />
                  <Route path="contracts/reports/performance" element={<ContractPerformanceReport />} />
                  <Route path="contracts/reports/renewals" element={<ContractRenewalReport />} />
                  <Route path="contracts/reports/compliance" element={<ContractComplianceReport />} />
                  <Route path="contracts/reports/financial" element={<ContractFinancialReport />} />
                  <Route path="timesheets" element={<Timesheets />} />
                  <Route path="timesheets/time-entry" element={<TimeEntry />} />
                  <Route path="timesheets/time-entry/form" element={<TimeEntryForm />} />
                  <Route path="timesheets/time-entry/edit" element={<TimeEntryForm />} />
                  <Route path="timesheets/time-entry/view" element={<TimeEntryForm />} />
                  <Route path="timesheets/weekly-timesheet" element={<WeeklyTimesheet />} />
                  <Route path="timesheets/weekly-timesheet/form" element={<WeeklyTimesheetForm />} />
                  <Route path="timesheets/weekly-timesheet/edit" element={<WeeklyTimesheetForm />} />
                  <Route path="timesheets/weekly-timesheet/view" element={<WeeklyTimesheetForm />} />
                  <Route path="timesheets/timesheet-approval" element={<TimesheetApproval />} />
                  <Route path="timesheets/timesheet-approval/view" element={<TimesheetApprovalForm />} />
                  <Route path="timesheets/timesheet-approval/approve" element={<TimesheetApprovalForm />} />
                  <Route path="timesheets/overtime" element={<Overtime />} />
                  <Route path="timesheets/overtime/form" element={<OvertimeForm />} />
                  <Route path="timesheets/overtime/edit" element={<OvertimeForm />} />
                  <Route path="timesheets/overtime/view" element={<OvertimeForm />} />
                  <Route path="expenses" element={<Expenses />} />
                  <Route path="expenses/employee-master" element={<EmployeeMaster />} />
                  <Route path="expenses/employee-master/form" element={<EmployeeMasterForm />} />
                  <Route path="expenses/expense-category-master" element={<ExpenseCategoryMaster />} />
                  <Route path="expenses/expense-category-master/form" element={<ExpenseCategoryMasterForm />} />
                  <Route path="expenses/expense-category-master/edit" element={<ExpenseCategoryMasterForm />} />
                  <Route path="expenses/expense-category-master/view" element={<ExpenseCategoryMasterForm />} />
                  <Route path="expenses/payment-method-master" element={<PaymentMethodMaster />} />
                  <Route path="expenses/payment-method-master/form" element={<PaymentMethodMasterForm />} />
                  <Route path="expenses/payment-method-master/edit" element={<PaymentMethodMasterForm />} />
                  <Route path="expenses/payment-method-master/view" element={<PaymentMethodMasterForm />} />
                  <Route path="expenses/approver-master" element={<ApproverMaster />} />
                  <Route path="expenses/approver-master/form" element={<ApproverMasterForm />} />
                  <Route path="expenses/approver-master/edit" element={<ApproverMasterForm />} />
                  <Route path="expenses/approver-master/view" element={<ApproverMasterForm />} />
                  <Route path="expenses/expense-claim" element={<ExpenseClaim />} />
                  <Route path="expenses/expense-claim/form" element={<ExpenseClaimForm />} />
                  <Route path="expenses/expense-claim/edit" element={<ExpenseClaimForm />} />
                  <Route path="expenses/expense-claim/view" element={<ExpenseClaimForm />} />
                  <Route path="expenses/expense-approval" element={<ExpenseApproval />} />
                  <Route path="expenses/expense-approval/view" element={<ExpenseApproval />} />
                  <Route path="expenses/expense-reimbursement" element={<ExpenseReimbursement />} />
                  <Route path="expenses/expense-reimbursement/form" element={<ExpenseReimbursementForm />} />
                  <Route path="expenses/expense-reimbursement/edit" element={<ExpenseReimbursementForm />} />
                  <Route path="expenses/expense-reimbursement/view" element={<ExpenseReimbursementForm />} />
                  <Route path="expenses/advance-payment" element={<AdvancePayment />} />
                  <Route path="expenses/advance-payment/form" element={<AdvancePaymentForm />} />
                  <Route path="expenses/advance-payment/edit" element={<AdvancePaymentForm />} />
                  <Route path="expenses/advance-payment/view" element={<AdvancePaymentForm />} />
                  <Route path="expenses/expense-analysis" element={<ExpenseAnalysis />} />
                  <Route path="expenses/employee-reports" element={<EmployeeReports />} />
                  <Route path="expenses/department-reports" element={<DepartmentReports />} />
                  <Route path="expenses/budget-reports" element={<BudgetReports />} />
                  <Route path="expenses/budget-vs-actual" element={<BudgetVsActual />} />
                  <Route path="expenses/financial-year-budget" element={<FinancialYearBudget />} />
                  <Route path="expenses/burn-category-master" element={<BurnExpenseCategoryMaster />} />
                  <Route path="expenses/burn-entry" element={<BurnExpenseEntry />} />
                  <Route path="expenses/burn-reports" element={<BurnReports />} />
                  <Route path="procurement" element={<Procurement />} />
                  <Route path="procurement/supplier-master" element={<SupplierMaster />} />
                  <Route path="procurement/supplier-master/form" element={<SupplierMasterForm />} />
                  <Route path="procurement/supplier-master/edit" element={<SupplierMasterForm />} />
                  <Route path="procurement/supplier-master/view" element={<SupplierMasterForm />} />
                  <Route path="procurement/product-master" element={<ProductMaster />} />
                  <Route path="procurement/product-master/form" element={<ProductMasterForm />} />
                  <Route path="procurement/product-master/edit" element={<ProductMasterForm />} />
                  <Route path="procurement/product-master/view" element={<ProductMasterForm />} />
                  <Route path="procurement/category-master" element={<CategoryMaster />} />
                  <Route path="procurement/category-master/form" element={<CategoryMasterForm />} />
                  <Route path="procurement/category-master/edit" element={<CategoryMasterForm />} />
                  <Route path="procurement/category-master/view" element={<CategoryMasterForm />} />
                  <Route path="procurement/procurement-service-master" element={<ProcurementServiceMaster />} />
                  <Route path="procurement/procurement-service-master/form" element={<ProcurementServiceMasterForm />} />
                  <Route path="procurement/procurement-service-master/edit" element={<ProcurementServiceMasterForm />} />
                  <Route path="procurement/procurement-service-master/view" element={<ProcurementServiceMasterForm />} />
                  <Route path="procurement/procurement-approver-master" element={<ProcurementApproverMaster />} />
                  <Route path="procurement/procurement-approver-master/form" element={<ProcurementApproverMasterForm />} />
                  <Route path="procurement/procurement-approver-master/edit" element={<ProcurementApproverMasterForm />} />
                  <Route path="procurement/procurement-approver-master/view" element={<ProcurementApproverMasterForm />} />
                  <Route path="procurement/purchase-requisition" element={<PurchaseRequisition />} />
                  <Route path="procurement/purchase-requisition/form" element={<PurchaseRequisitionForm />} />
                  <Route path="procurement/purchase-requisition/edit" element={<PurchaseRequisitionForm />} />
                  <Route path="procurement/purchase-requisition/view" element={<PurchaseRequisitionForm />} />
                  <Route path="procurement/purchase-order" element={<PurchaseOrder />} />
                  <Route path="procurement/purchase-order/form" element={<PurchaseOrderForm />} />
                  <Route path="procurement/purchase-order/edit" element={<PurchaseOrderForm />} />
                  <Route path="procurement/purchase-order/view" element={<PurchaseOrderForm />} />
                  <Route path="procurement/goods-receipt-note" element={<GoodsReceiptNote />} />
                  <Route path="procurement/goods-receipt-note/form" element={<GoodsReceiptNoteForm />} />
                  <Route path="procurement/goods-receipt-note/edit" element={<GoodsReceiptNoteForm />} />
                  <Route path="procurement/goods-receipt-note/view" element={<GoodsReceiptNoteForm />} />
                  <Route path="procurement/vendor-invoice" element={<VendorInvoice />} />
                  <Route path="procurement/vendor-invoice/form" element={<VendorInvoiceForm />} />
                  <Route path="procurement/vendor-invoice/edit" element={<VendorInvoiceForm />} />
                  <Route path="procurement/vendor-invoice/view" element={<VendorInvoiceForm />} />
                  <Route path="procurement/purchase-analysis" element={<PurchaseAnalysis />} />
                  <Route path="procurement/supplier-reports" element={<SupplierReports />} />
                  <Route path="procurement/inventory-reports" element={<InventoryReports />} />
                  <Route path="procurement/cost-reports" element={<CostReports />} />
                  <Route path="subscriptions/list" element={<SubscriptionList />} />
                  <Route path="subscriptions/new" element={<SubscriptionForm />} />
                  <Route path="subscriptions/edit/:id" element={<SubscriptionForm />} />
                  <Route path="subscriptions/view/:id" element={<SubscriptionForm />} />
                  <Route path="subscriptions/renewals" element={<RenewalList />} />
                  <Route path="subscriptions/payments" element={<SubscriptionPaymentList />} />
                  <Route path="subscriptions/payments/new" element={<SubscriptionPaymentForm />} />
                  <Route path="subscriptions/payments/edit/:id" element={<SubscriptionPaymentForm />} />
                  <Route path="subscriptions/payments/view/:id" element={<SubscriptionPaymentForm />} />
                  <Route path="subscriptions/expirations" element={<ExpirationList />} />
                  <Route path="subscriptions" element={<Subscriptions />} />
                  <Route path="assets" element={<Assets />} />
                  <Route path="assets/asset-type-master" element={<AssetTypeMaster />} />
                  <Route path="assets/asset-type-master/form" element={<AssetTypeMasterForm />} />
                  <Route path="assets/asset-type-master/edit" element={<AssetTypeMasterForm />} />
                  <Route path="assets/asset-type-master/view" element={<AssetTypeMasterForm />} />
                  <Route path="assets/location-master" element={<AssetLocationMaster />} />
                  <Route path="assets/location-master/form" element={<AssetLocationMasterForm />} />
                  <Route path="assets/location-master/edit" element={<AssetLocationMasterForm />} />
                  <Route path="assets/location-master/view" element={<AssetLocationMasterForm />} />
                  <Route path="assets/vendor-master" element={<AssetVendorMaster />} />
                  <Route path="assets/vendor-master/form" element={<AssetVendorMasterForm />} />
                  <Route path="assets/vendor-master/edit" element={<AssetVendorMasterForm />} />
                  <Route path="assets/vendor-master/view" element={<AssetVendorMasterForm />} />
                  <Route path="assets/maintenance-provider-master" element={<MaintenanceProviderMaster />} />
                  <Route path="assets/maintenance-provider-master/form" element={<MaintenanceProviderMasterForm />} />
                  <Route path="assets/maintenance-provider-master/edit" element={<MaintenanceProviderMasterForm />} />
                  <Route path="assets/maintenance-provider-master/view" element={<MaintenanceProviderMasterForm />} />
                  <Route path="assets/acquisitions" element={<AssetAcquisitions />} />
                  <Route path="assets/acquisitions/form" element={<AssetAcquisitionForm />} />
                  <Route path="assets/acquisitions/edit" element={<AssetAcquisitionForm />} />
                  <Route path="assets/acquisitions/view" element={<AssetAcquisitionForm />} />
                  <Route path="assets/assignments" element={<AssetAssignments />} />
                  <Route path="assets/assignments/form" element={<AssetAssignmentForm />} />
                  <Route path="assets/assignments/edit" element={<AssetAssignmentForm />} />
                  <Route path="assets/assignments/view" element={<AssetAssignmentForm />} />
                  <Route path="assets/maintenance" element={<AssetMaintenanceList />} />
                  <Route path="assets/maintenance/form" element={<AssetMaintenanceForm />} />
                  <Route path="assets/maintenance/edit" element={<AssetMaintenanceForm />} />
                  <Route path="assets/maintenance/view" element={<AssetMaintenanceForm />} />
                  <Route path="assets/disposals" element={<AssetDisposals />} />
                  <Route path="assets/disposals/form" element={<AssetDisposalForm />} />
                  <Route path="assets/disposals/edit" element={<AssetDisposalForm />} />
                  <Route path="assets/disposals/view" element={<AssetDisposalForm />} />
                  <Route path="assets/reports/valuation" element={<AssetValuationReport />} />
                  <Route path="assets/reports/utilization" element={<AssetUtilizationReport />} />
                  <Route path="assets/reports/maintenance" element={<AssetMaintenanceReport />} />
                  <Route path="assets/reports/financial" element={<AssetFinancialReport />} />
                  <Route path="accounts" element={<Billing />} />
                  <Route path="accounts/payments" element={<Payments />} />
                  <Route path="accounts/payments/new" element={<PaymentForm />} />
                  <Route path="accounts/cash-accounts" element={<CashAccountMaster />} />
                  <Route path="accounts/cash-transactions" element={<CashTransactions />} />
                  <Route path="accounts/reports/invoice-aging" element={<InvoiceAgingReport />} />
                  <Route path="accounts/reports/sundry-debtors" element={<SundryDebtorsReport />} />
                  <Route path="accounts/reports/outstanding-payments" element={<OutstandingPaymentsReport />} />
                  <Route path="accounts/reports/founder-control" element={<FounderControlReport />} />
                  <Route path="accounts/reports/burn-discipline" element={<BurnDisciplineReport />} />
                  <Route path="accounts/reports/runway-sensitivity" element={<RunwaySensitivityReport />} />
                  <Route path="management" element={<Management />} />
                  <Route path="management/reports/directors-review" element={<DirectorsBusinessReview />} />
                  <Route path="management/reports/mis-snapshot" element={<MisSnapshotReport />} />
                  <Route path="management/reports/financial-health" element={<FinancialHealthReport />} />
                  <Route path="management/reports/sales-pipeline" element={<SalesPipelineRevenueReport />} />
                  <Route path="management/reports/project-portfolio" element={<ProjectPortfolioHealthReport />} />
                  <Route path="management/reports/resource-capacity" element={<ResourceCapacityReport />} />
                  <Route path="management/reports/customer-collection" element={<CustomerCollectionHealthReport />} />
                  <Route path="management/reports/expense-budget" element={<ExpenseBudgetPerformanceReport />} />
                  <Route path="management/reports/renewals" element={<RenewalsCommitmentsReport />} />
                  <Route path="management/reports/risk-actions" element={<RiskComplianceActionTracker />} />
                  <Route path="ai-assistant" element={<AIAssistant />} />
                  <Route path="development" element={<Development />} />
                  <Route path="settings" element={<Settings />} />
                  
                  {/* Settings User Master Routes */}
                  <Route path="settings/user-master" element={<UserMaster />} />
                  <Route path="settings/user-master/form" element={<UserMasterForm />} />
                  <Route path="settings/user-master/edit/:id" element={<UserMasterEdit />} />
                  <Route path="settings/user-master/view/:id" element={<UserMasterView />} />
                  
                  {/* Settings Security Master Routes */}
                  <Route path="settings/security-master" element={<SecurityMaster />} />
                  <Route path="settings/organisation" element={<OrganisationMaster />} />
                  <Route path="settings/system" element={<SystemConfiguration />} />
                  <Route path="settings/notifications" element={<NotificationsHub />} />
                  <Route path="settings/menu-item-master" element={<MenuItemMaster />} />
                  <Route path="settings/menu-item-master/form" element={<MenuItemMasterForm />} />
                  <Route path="settings/menu-item-master/edit" element={<MenuItemMasterEdit />} />
                  <Route path="settings/menu-item-master/view" element={<MenuItemMasterView />} />

                  <Route path="settings/submodule-master" element={<SubmoduleMaster />} />
                  <Route path="settings/submodule-master/form" element={<SubmoduleMasterForm />} />
                  <Route path="settings/submodule-master/edit" element={<SubmoduleMasterEdit />} />
                  <Route path="settings/submodule-master/view" element={<SubmoduleMasterView />} />
                  <Route path="settings/module-permissions" element={<ModulePermissions />} />
                  <Route path="settings/email-notifications" element={<EmailNotifications />} />
                  <Route path="settings/gst-reminder-settings" element={<GstReminderSettings />} />
                  <Route path="settings/export-details" element={<ExportDetails />} />
                  
                  {/* Settings Role Master Routes */}
                  <Route path="settings/role-master" element={<RoleMaster />} />
                  <Route path="settings/role-master/form" element={<RoleMasterForm />} />
                  <Route path="settings/role-master/edit" element={<RoleMasterEdit />} />
                  <Route path="settings/role-master/view" element={<RoleMasterView />} />
                  
                  <Route path="support" element={<Support />} />
                  <Route path="support/support-tickets" element={<SupportTicketList />} />
                  <Route path="support/support-tickets/form" element={<SupportTicketForm />} />
                  <Route path="support/support-tickets/edit/:id" element={<SupportTicketEdit />} />
                  <Route path="support/support-tickets/view/:id" element={<SupportTicketView />} />
                  
                  {/* Sales Master Data Routes */}
                  <Route path="sales/sac-master" element={<SACMaster />} />
                  <Route path="sales/sac-master/form" element={<SACMasterForm />} />
                  <Route path="sales/sac-master/edit" element={<SACMasterEdit />} />
                  <Route path="sales/sac-master/view" element={<SACMasterView />} />
                  
                  {/* Sales Service Master Routes */}
                  <Route path="sales/service-master" element={<ServiceMaster />} />
                  <Route path="sales/service-master/form" element={<ServiceMasterForm />} />
                  <Route path="sales/service-master/edit" element={<ServiceMasterEdit />} />
                  <Route path="sales/service-master/view" element={<ServiceMasterView />} />
                  
                  {/* Sales Payment Terms Master Routes */}
                  <Route path="sales/payment-terms-master" element={<PaymentTermsMaster />} />
                  <Route path="sales/payment-terms-master/form" element={<PaymentTermsMasterForm />} />
                  <Route path="sales/payment-terms-master/edit" element={<PaymentTermsMasterEdit />} />
                  <Route path="sales/payment-terms-master/view" element={<PaymentTermsMasterView />} />
                  
                  {/* Sales Customer Master Routes */}
                  <Route path="sales/customer-master" element={<CustomerMaster />} />
                  <Route path="sales/customer-master/form" element={<CustomerMasterForm />} />
                  <Route path="sales/customer-master/edit/:id" element={<CustomerMasterEdit />} />
                  {/* Fallback for old route without ID - redirect to list */}
                  <Route path="sales/customer-master/edit" element={<Navigate to="/sales/customer-master" replace />} />
                  <Route path="sales/customer-master/view" element={<CustomerMasterView />} />
                  
                  {/* Sales Pipeline Routes */}
                  <Route path="sales/stage-master" element={<SalesStageMaster />} />
                  <Route path="sales/opportunities" element={<OpportunityList />} />
                  
                  {/* Sales Tax Invoice Routes */}
                  <Route path="sales/tax-invoice" element={<TaxInvoice />} />
                  <Route path="sales/tax-invoice/new" element={<TaxInvoiceForm />} />
                  <Route path="sales/tax-invoice/edit/:id" element={<TaxInvoiceForm />} />
                  <Route path="sales/tax-invoice/view/:id" element={<TaxInvoiceForm />} />
                  <Route path="sales/tax-invoice/approve/:id" element={<TaxInvoiceForm />} />
                  
                  {/* Proforma Invoice Routes */}
                  <Route path="sales/proforma-invoice" element={<ProformaInvoice />} />
                  <Route path="sales/proforma-invoice/new" element={<ProformaInvoiceForm />} />
                  <Route path="sales/proforma-invoice/edit/:id" element={<ProformaInvoiceForm />} />
                  <Route path="sales/proforma-invoice/view/:id" element={<ProformaInvoiceForm />} />
                  <Route path="sales/proforma-invoice/approve/:id" element={<ProformaInvoiceForm />} />
                  
                  {/* Sales Quotation Routes */}
                  <Route path="sales/sales-quotation" element={<SalesQuotation />} />
                  <Route path="sales/sales-quotation/new" element={<SalesQuotationForm />} />
                  <Route path="sales/sales-quotation/edit/:id" element={<SalesQuotationForm />} />
                  <Route path="sales/sales-quotation/view/:id" element={<SalesQuotationForm />} />
                  <Route path="sales/sales-quotation/approve/:id" element={<SalesQuotationForm />} />
                  <Route path="sales/sales-quotation/send/:id" element={<SalesQuotationForm />} />
                  
                  {/* Sales Reports Routes */}
                       <Route path="sales/reports/overview" element={<SalesOverviewReport />} />
                       <Route path="sales/reports/tax-invoice" element={<TaxInvoiceReport />} />
                       <Route path="sales/reports/proforma-invoice" element={<ProformaInvoiceReport />} />
                       <Route path="sales/reports/sales-quotation" element={<SalesQuotationReport />} />
                       <Route path="sales/reports/sales-register" element={<SalesRegisterReport />} />
                       <Route path="sales/reports/pipeline" element={<PipelineReports />} />
                  
                  {/* CRM Prospect Master Routes */}
                  <Route path="crm/prospect-master" element={<ProspectMaster />} />
                  <Route path="crm/prospect-master/new" element={<ProspectMasterForm />} />
                  <Route path="crm/prospect-master/edit" element={<ProspectMasterEdit />} />
                  <Route path="crm/prospect-master/view" element={<ProspectMasterView />} />
                  <Route path="crm/upload-prospect" element={<UploadProspect />} />
                  
                  {/* CRM Lead Source Master Routes */}
                  <Route path="crm/lead-source-master" element={<LeadSourceMaster />} />
                  <Route path="crm/lead-source-master/new" element={<LeadSourceMasterForm />} />
                  <Route path="crm/lead-source-master/edit/:id" element={<LeadSourceMasterEdit />} />
                  <Route path="crm/lead-source-master/view/:id" element={<LeadSourceMasterView />} />
                  
        {/* CRM Campaign Master Routes */}
        <Route path="crm/campaign-master" element={<CampaignMaster />} />
        <Route path="crm/campaign-master/new" element={<CampaignMasterForm />} />
        <Route path="crm/campaign-master/edit/:id" element={<CampaignMasterEdit />} />
        <Route path="crm/campaign-master/view/:id" element={<CampaignMasterView />} />
        
        {/* CRM Lead Management Routes */}
        <Route path="crm/lead-management" element={<LeadManagement />} />
        <Route path="crm/lead-management/new" element={<LeadManagementForm />} />
        
        {/* CRM Lead Tracking Routes */}
        <Route path="crm/lead-tracking" element={<LeadTracking />} />
        <Route path="crm/lead-tracking/new" element={<LeadTrackingForm />} />
        
        {/* CRM Demo Scheduling Routes */}
        <Route path="crm/demo-scheduling" element={<DemoScheduling />} />
        <Route path="crm/demo-scheduling/new" element={<DemoSchedulingForm />} />
        
        {/* CRM Commercial Proposal Routes */}
        <Route path="crm/commercial-proposal" element={<CommercialProposal />} />
        <Route path="crm/commercial-proposal/new" element={<CommercialProposalForm />} />
        
        {/* CRM Email Routes */}
        <Route path="crm/emails" element={<Emails />} />
        <Route path="crm/emails/new" element={<EmailForm />} />
        
        {/* CRM Calls Routes */}
        <Route path="crm/calls" element={<Calls />} />
        <Route path="crm/calls/new" element={<CallsForm />} />
        <Route path="crm/calls/edit/:id" element={<CallsForm />} />
        <Route path="crm/calls/view/:id" element={<CallsForm />} />
        
        {/* CRM Follow-up Routes */}
        <Route path="crm/follow-up" element={<FollowUp />} />
        <Route path="crm/follow-up/new" element={<FollowUpForm />} />
        <Route path="crm/follow-up/edit/:id" element={<FollowUpForm />} />
        <Route path="crm/follow-up/view/:id" element={<FollowUpForm />} />
        
                  
                  {/* Global Master Routes */}
                  <Route path="settings/global-master" element={<GlobalMaster />} />
                  <Route path="settings/company-master" element={<CompanyMaster />} />
                  
                  
                  {/* Dropdown Master Routes */}
                  <Route path="settings/dropdown-master" element={<DropdownMaster />} />
                  <Route path="settings/dropdown-master/form" element={<DropdownMasterForm />} />
                  <Route path="settings/dropdown-master/edit" element={<DropdownMasterEdit />} />
                  <Route path="settings/dropdown-master/view" element={<DropdownMasterView />} />
                  
                  {/* Auto Increment Master Routes */}
                  <Route path="settings/auto-increment-master" element={<AutoIncrementMaster />} />
                  <Route path="settings/auto-increment-master/form" element={<AutoIncrementMasterForm />} />
                  <Route path="settings/auto-increment-master/edit" element={<AutoIncrementMasterEdit />} />
                  <Route path="settings/auto-increment-master/view" element={<AutoIncrementMasterView />} />
                  
                  {/* Settings Transactions - Coming Soon placeholders */}
                  <Route path="settings/application-parameters" element={<ApplicationParameters />} />
                  <Route path="settings/audit" element={<ComingSoon />} />
                  <Route path="settings/user-changes" element={<ComingSoon />} />
                  <Route path="settings/security-updates" element={<ComingSoon />} />
                  <Route path="settings/config-changes" element={<ComingSoon />} />
                  <Route path="settings/data-operations" element={<ComingSoon />} />
                  
                  {/* Add more routes here as we build the modules */}
                  {/* Removed catch-all redirect to preserve current page on refresh */}
                </Route>
                
                {/* Standalone Report Routes (No Sidebar) */}
                <Route 
                  path="/crm/reports/sales-performance" 
                  element={
                    <ProtectedRoute>
                      <ReportLayout>
                        <SalesPerformanceReport />
                      </ReportLayout>
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/crm/reports/lead-reports" 
                  element={
                    <ProtectedRoute>
                      <ReportLayout>
                        <LeadReports />
                      </ReportLayout>
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/crm/reports/customer-analytics" 
                  element={
                    <ProtectedRoute>
                      <ReportLayout>
                        <CustomerAnalytics />
                      </ReportLayout>
                    </ProtectedRoute>
                  } 
                />
                {/* Tax Invoice Print Route (No Sidebar/Header) */}
                <Route 
                  path="/sales/tax-invoice/print/:id" 
                  element={
                    <ProtectedRoute>
                      <TaxInvoicePrint />
                    </ProtectedRoute>
                  } 
                />
                {/* Proforma Invoice Print Route (No Sidebar/Header) */}
                <Route 
                  path="/sales/proforma-invoice/print/:id" 
                  element={
                    <ProtectedRoute>
                      <ProformaInvoicePrint />
                    </ProtectedRoute>
                  } 
                />
                {/* Sales Quotation Print Route (No Sidebar/Header) */}
                <Route 
                  path="/sales/sales-quotation/print/:id" 
                  element={
                    <ProtectedRoute>
                      <SalesQuotationPrint />
                    </ProtectedRoute>
                  } 
                />
          </Routes>
        </div>
        <ToastContainer 
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </AuthProvider>
  )
}

export default App

